import "../styles/OurProgram.css";
import Card from "react-bootstrap/Card";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getUnit, getActiveBatch, getInternalActiveBatch, getMovingActiveBatch } from "../api_folder/api";

const BASE = "https://spmb.asy-syukriyyah.sch.id/";

const toList = (d) => (Array.isArray(d) ? d : []); // {"status":"fail"} -> []

const newData = {
  id_unit: "4",
  grup_unit: "1",
  name_unit: "TKIT Asy-Syukriyyah",
  logo_unit: "images/TUMBNAIL_TKIT.jpg",
  logo_buka: "images/TUMBNAIL_TKIT_BUKA.jpg",
  url: "/unit-tkit",
  sort_order: "1",
};

function OurProgram() {
  const [units, setUnits] = useState([]);
  const [batch, setBatch] = useState({ reguler: [], internal: [], moving: [] });

  useEffect(() => {
    Promise.all([
      getUnit(),
      getActiveBatch(),
      getInternalActiveBatch(),
      getMovingActiveBatch(),
    ])
      .then(([u, reguler, internal, moving]) => {
        setUnits(u.data);
        setBatch({ reguler: reguler.data, internal: internal.data, moving: moving.data });
      })
      .catch(console.error);
  }, []);

  // open if ANY of the 3 registration types is active
  // inside the component, replacing the old global `open`
  const openUnitIds = new Set(
    [
      ...toList(batch.reguler),
      ...toList(batch.internal),
      ...toList(batch.moving),
    ].map((b) => String(b.id_unit)) // <- field that links a batch to its unit
  );

  const nfilter = [...units]
    .sort((a, b) => a.sort_order - b.sort_order)
    .filter((unit) => unit.sort_order >= 5 && unit.id_unit !== "10");

  if (units.length > 0) nfilter.unshift(newData);

  return (
    <Container className="page2">
      <div>
        <h1 className="title text-center">Program kami</h1>
        <p className="text-center" style={{ color: "#697586" }}>
          Program sekolah pilihan di Asy-Syukriyyah Islamic School
        </p>
      </div>

      {nfilter.length > 0 && (
        <Row className="gap-xxl-5 gap-xs-5 gap-md-4 justify-content-md-center flex-nowrap flex-md-wrap scroll-x p-3">

          {nfilter.map((e) => {
            const open = openUnitIds.has(String(e.id_unit));

            return (
              <Col xs={11} md={5} lg={4} xl={3} xxl={3} key={e.id_unit} className="p-2 d-flex">
                <Link
                  to={e.url}
                  className="d-flex flex-column p-1 mx-auto card list h-100 w-100"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <Card.Img
                    variant="top"
                    src={BASE + (open ? e.logo_buka : e.logo_unit)}
                    alt={e.name_unit}
                    style={{
                      width: "100%",
                      aspectRatio: "1/1",
                      objectFit: "cover",
                      borderTopLeftRadius: "20px",
                      borderTopRightRadius: "20px",
                    }}
                  />
                  <Card.Body className="d-flex flex-column flex-grow-1 justify-content-between mb-2">
                    <Card.Title>{e.name_unit}</Card.Title>
                    <Button as="span" variant={open ? "success" : "unitClosed"} className="rounded-pill">
                      Daftar
                    </Button>
                  </Card.Body>
                </Link>
              </Col>
            );
          })}
        </Row>
      )}
    </Container>
  );
}
export default OurProgram;
